import { render, staticRenderFns } from "./favorite-viewer.vue?vue&type=template&id=65f16f70&scoped=true&"
import script from "./favorite-viewer.vue?vue&type=script&lang=ts&"
export * from "./favorite-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./favorite-viewer.vue?vue&type=style&index=0&id=65f16f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f16f70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCol,VDataTable,VIcon,VImg,VOverlay,VProgressCircular,VRow,VSlider})
